export const SAVE_PROSPECT_PROFILE = 'app/ProspectProfile/SAVE_PROSPECT_PROFILE';
export const SAVE_PROSPECT_PROFILE_SUCCESS = 'app/ProspectProfile/SAVE_PROSPECT_PROFILE_SUCCESS';
export const SAVE_PROSPECT_PROFILE_ERROR = 'app/ProspectProfile/SAVE_PROSPECT_PROFILE_ERROR';

export const CLEAR_PROSPECT_MESSAGES = 'app/ProspectProfile/CLEAR_PROSPECT_MESSAGES';
